<div class="tw-flex tw-flex-col tw-justify-center tw-min-h-screen">
  <public-tracking-header></public-tracking-header>
  <div class="tw-container-lg tw-flex tw-flex-1">
    <ng-content></ng-content>
  </div>
  <public-tracking-footer></public-tracking-footer>
</div>
